import { render, staticRenderFns } from "./carStoreOrder.vue?vue&type=template&id=06453f12&scoped=true&"
import script from "./carStoreOrder.vue?vue&type=script&lang=js&"
export * from "./carStoreOrder.vue?vue&type=script&lang=js&"
import style0 from "./carStoreOrder.vue?vue&type=style&index=0&id=06453f12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06453f12",
  null
  
)

export default component.exports